/* istanbul ignore file */

import { FieldIdentifier } from '../field-identifier';
import { EmailProperties } from './email-properties';

export class Action {
    actionType: number;
    selectedField?: FieldIdentifier;
    valueToSet?: Date | string[] | number | string;
    setDateToToday?: boolean;
    emailProperties?: EmailProperties;
}
